import { HttpErrorResponse } from '@angular/common/http';
import {SnackBarService} from '../../core/services/snackbar.service';

/** Codes whose messages were written for the user and must be shown as-is. */
const INTENTIONAL_ERROR_CODES = ['2009', '2005', '2003', '2001', '2011'];

const TECHNICAL_ERROR = /^error\s*:|bad sql|jooq|sqlstate|unique constraint|duplicate key value|org\.springframework|com\.fasterxml|java\.lang|javax\.|jakarta\.|\.exception\b|exception in thread|\bat [\w.$]+\(|select\s+["'`]/i;

export class ServerErrorUtils {

  static getValidationMessages(response: HttpErrorResponse): string[] {
    const body = response?.error?.error;
    if (!body || !Array.isArray(body.messages) || body.messages.length === 0) {
      return null;
    }
    if (INTENTIONAL_ERROR_CODES.includes(body.code)) {
      return body.messages;
    }
    const safe = body.messages.filter(isUserFacingApiMessage);
    return safe.length ? safe : null;
  }

  static serverValidationOrMsg(e: HttpErrorResponse, sbs: SnackBarService, defaultMsg: string) {
    const messages = ServerErrorUtils.getValidationMessages(e);
    if (messages) {
      messages.forEach(m => sbs.error(m));
    } else {
      sbs.error(defaultMsg);
    }
  }

}

function isUserFacingApiMessage(message: unknown): message is string {
  if (typeof message !== 'string') {
    return false;
  }
  const text = message.trim();
  if (!text || text.length > 400 || /[\r\n]/.test(text)) {
    return false;
  }
  return !TECHNICAL_ERROR.test(text);
}
